__turbopack_context__.v({
  "container": "DiyOptionBlock-module__WBOQ4G__container",
  "copy": "DiyOptionBlock-module__WBOQ4G__copy",
  "description": "DiyOptionBlock-module__WBOQ4G__description",
  "icon": "DiyOptionBlock-module__WBOQ4G__icon",
  "title": "DiyOptionBlock-module__WBOQ4G__title",
});
